import script from "./sharePoster.vue?vue&type=script&setup=true&lang=js"
export * from "./sharePoster.vue?vue&type=script&setup=true&lang=js"

import "./sharePoster.vue?vue&type=style&index=0&id=79a13a09&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/pre__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a13a09"]])

export default __exports__